import React from "react";
import { cn } from "@/lib/utils";

/** Raised neumorphic surface. `inset` presses it into the page; `flat` is the lighter inner-panel shadow. */
export function Card({ as: Tag = "div", inset = false, flat = false, interactive = false, className, children, ...rest }) {
  return (
    <Tag
      className={cn(inset ? "neu-inset" : flat ? "neu-card-flat" : "neu-card", interactive && "card-hover cursor-pointer", className)}
      {...rest}
    >
      {children}
    </Tag>
  );
}

/** Title with the admin panel's orange accent bar. */
export function SectionTitle({ children, count }) {
  return (
    <div className="flex items-center gap-2 min-w-0">
      <span className="w-1 h-4 bg-brand-orange rounded-full shrink-0" />
      <h3 className="section-title truncate">{children}</h3>
      {count !== undefined && <span className="badge text-[10px] py-0.5">{count}</span>}
    </div>
  );
}

/** Card with an accent-bar header row (title, subtitle, action) and padded body. */
export function SectionCard({ title, subtitle, count, action, className, bodyClassName, children }) {
  return (
    <Card className={className}>
      {(title || action) && (
        <div className="flex items-start justify-between gap-3 px-4 pt-4 pb-2">
          <div className="min-w-0">
            {title && <SectionTitle count={count}>{title}</SectionTitle>}
            {subtitle && <p className="text-[11px] text-slate-500 mt-1 ml-3">{subtitle}</p>}
          </div>
          {action && <div className="shrink-0">{action}</div>}
        </div>
      )}
      <div className={cn("px-4 pb-4", !(title || action) && "pt-4", bodyClassName)}>{children}</div>
    </Card>
  );
}

/** Small "View all ›" style header link. */
export function CardLink({ as: Tag = "button", children, ...rest }) {
  return (
    <Tag className="text-[11px] text-brand-blue hover:text-brand-orange font-bold inline-flex items-center gap-0.5 transition-colors" {...rest}>
      {children}
    </Tag>
  );
}
